// extracted by mini-css-extract-plugin
export var base = "SACodeOfPractice-module--base--3a416";